
import {ImageFile} from "./imageFile";

export class ZendeskTicket {
    public email: string = "";
    public subject: string = "";
    public description: string = "";
    public attachments: ImageFile[] = [];
    
    public boardIdentifier: string | null;
    public currentUrl: string | null;
    public systemUserId: number | null;
    public distributorId: number | null;
    public groupId: number | null;
    public siteId: number | null;
    public accountId: number | null;
    
    public diagInfo: string | null;
}